module.exports = __webpack_public_path__ + "stockLibrary/landing-modal-img-1-2d138cbc8605ee49538331b3271c58df.png";